import { ExportButton } from "../../../components/ExportButton/ExportButton";
import { withPropsTransformer, withShouldRenderProp } from "../../../hocs";
const BaseExportButtonWithShouldRenderProp = withShouldRenderProp(ExportButton);
const exportButtonPropsTransformer = (inputProps) => {
    return inputProps.data;
};
export const ToolbarExportButton = withPropsTransformer(exportButtonPropsTransformer)(BaseExportButtonWithShouldRenderProp);
//# sourceMappingURL=ToolbarExportButton.js.map